const TIER_LABELS: Record<string, string> = {
  DEVELOPMENT: "DEV",
  "gb-nhs-uat": "UAT",
  "gb-nhs-staging": "STAGING",
};

export function getEnvironmentLabel(): string | null {
  const appEnvironment = import.meta.env.APP_ENVIRONMENT;
  return appEnvironment ? TIER_LABELS[appEnvironment] ?? null : null;
}

// ENG-21756 Unset stays false on purpose: a misconfigured deployed build should still report.
export function isDevelopmentEnvironment(appEnvironment: string | undefined): boolean {
  return appEnvironment === "DEVELOPMENT";
}
